import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@weave-mui/styles';
import CssBaseline from '@weave-mui/cssbaseline';
import { useAuth } from './auth/AuthProvider';
import { loadAppTheme } from './theme';
import Layout from './components/Layout';
import KanbanBoard from './components/KanbanBoard/KanbanBoard';
import SchedulesBoard from './components/SchedulesBoard/SchedulesBoard';
import AgentsBoard from './components/AgentsBoard/AgentsBoard';
import SkillsBoard from './components/SkillsBoard/SkillsBoard';
import AnalyticsBoard from './components/AnalyticsBoard/AnalyticsBoard';
import SettingsPanel from './components/SettingsPanel/SettingsPanel';
import LoginPage from './pages/LoginPage';
function AppRoutes() {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading)
        return null;
    // The APS OAuth app is registered with redirect_uri = origin root ('/'), so the
    // callback lands here with ?code=/?error= regardless of path. Handle it before
    // the "/" route's <Navigate to="/login"> below, which would otherwise fire first
    // and drop the query string (Navigate doesn't carry over the current search).
    const params = new URLSearchParams(location.search);
    if (!user && (params.has('code') || params.has('error'))) {
        return _jsx(LoginPage, {});
    }
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: user ? _jsx(Navigate, { to: "/", replace: true }) : _jsx(LoginPage, {}) }), _jsxs(Route, { path: "/", element: user ? _jsx(Layout, {}) : _jsx(Navigate, { to: "/login", replace: true }), children: [_jsx(Route, { index: true, element: _jsx(KanbanBoard, {}) }), _jsx(Route, { path: "tasks/:taskId", element: _jsx(KanbanBoard, {}) }), _jsx(Route, { path: "schedules", element: _jsx(SchedulesBoard, {}) }), _jsx(Route, { path: "schedules/:scheduleId", element: _jsx(SchedulesBoard, {}) }), _jsx(Route, { path: "agents", element: _jsx(AgentsBoard, {}) }), _jsx(Route, { path: "agents/:agentId", element: _jsx(AgentsBoard, {}) }), _jsx(Route, { path: "skills", element: _jsx(SkillsBoard, {}) }), _jsx(Route, { path: "skills/:skillId", element: _jsx(SkillsBoard, {}) }), _jsx(Route, { path: "analytics", element: _jsx(AnalyticsBoard, {}) }), _jsx(Route, { path: "settings", element: _jsx(SettingsPanel, {}) })] }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: user ? '/' : '/login', replace: true }) })] }));
}
export default function App() {
    const [theme, setTheme] = useState(null);
    const [themeInitialized, setThemeInitialized] = useState(false);
    const [themeError, setThemeError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        void loadAppTheme()
            .then((t) => {
            if (!cancelled) {
                setTheme(t);
                setThemeInitialized(true);
            }
        })
            .catch((err) => {
            if (!cancelled) {
                setThemeError(err instanceof Error ? err : new Error(String(err)));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    if (themeError) {
        return (_jsxs("div", { style: { padding: 24, fontFamily: 'sans-serif' }, children: [_jsx("h2", { children: "Failed to load design theme" }), _jsx("p", { children: themeError.message })] }));
    }
    if (!themeInitialized || !theme)
        return null;
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(AppRoutes, {})] }));
}
